"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.executeQuery = void 0;
const errors_1 = require("./errors");
const exports_1 = require("./exports");
/**
 * Executes the given query and returns any data from the response.
 *
 * @param query - query configuration details
 */
const executeQuery = async (query) => {
    var _a, _b, _c;
    try {
        // support using given auth token or getting one
        let Authorization = (_a = query.headers) === null || _a === void 0 ? void 0 : _a.Authorization;
        if (!Authorization) {
            const authToken = await (0, exports_1.getAuthToken)();
            if (!authToken.data) {
                return (0, errors_1.errorResult)('QUERY_FAILURE', 'Could not get auth token.');
            }
            Authorization = `Bearer ${authToken.data}`;
        }
        // we support some special handling to make using GraphQL easier
        const isGraphQl = typeof query.query === 'string';
        const body = isGraphQl
            ? JSON.stringify({
                query: query.query,
            })
            : query.data;
        const response = await fetch(query.endpoint, {
            method: ((_b = query.verb) !== null && _b !== void 0 ? _b : isGraphQl) ? 'POST' : 'GET',
            body,
            headers: Object.assign({ Authorization, 'Content-Type': 'application/json' }, query.headers),
        });
        if (response.status !== 200) {
            return (0, errors_1.errorResult)('QUERY_FAILURE', `Query failed with status ${response.status}.`);
        }
        const responseData = await response.json();
        if (query.getDataFromResponse) {
            return {
                ok: true,
                data: query.getDataFromResponse(responseData),
            };
        }
        if (isGraphQl) {
            if (((_c = responseData.errors) === null || _c === void 0 ? void 0 : _c.length) > 0) {
                return (0, errors_1.errorResult)('QUERY_FAILURE', 'Error response from server for provided GraphQL query.', new errors_1.GraphQLError(responseData.errors, query.query));
            }
            if (!responseData.data) {
                return (0, errors_1.errorResult)('QUERY_FAILURE', 'No data returned from GraphQL query.');
            }
            return {
                ok: true,
                // we use the first (should be only) value in the response data
                data: Object.values(responseData.data)[0],
            };
        }
        return {
            ok: true,
            data: responseData,
        };
    }
    catch (ex) {
        return (0, errors_1.errorResult)('QUERY_FAILURE', `Unexpected error occurred while executing query.`, ex);
    }
};
exports.executeQuery = executeQuery;
